import React from "react";
import { Phone, MapPin, Sparkles, Home, Facebook, Clock } from "lucide-react";

const FooterBanner = () => (
  <section className="footer-banner-gradient relative" data-testid="footer-banner">
    <div className="container-hc py-16 md:py-20">
      <div className="grid md:grid-cols-2 gap-10 text-center md:text-left items-center max-w-4xl mx-auto">
        <BannerItem
          icon={<Phone size={22} />}
          label="CALL US"
          value={
            <a href="tel:9362750222" className="font-serif-display text-3xl md:text-4xl text-white hover:text-[#c4d8ec] transition-colors">
              (936) 275-0222
            </a>
          }
        />
        <BannerItem
          icon={<MapPin size={22} />}
          label="VISIT US"
          value={
            <div className="font-serif-display text-2xl md:text-3xl text-white leading-tight">
              1997 Davidson Drive
              <br />
              San Augustine, TX 75972
            </div>
          }
        />
      </div>
    </div>
  </section>
);

const BannerItem = ({ icon, label, value }) => (
  <div className="flex flex-col md:flex-row gap-4 md:gap-5 items-center md:items-start">
    <div className="w-14 h-14 rounded-full border-2 border-[#c4d8ec]/40 flex items-center justify-center text-[#c4d8ec] flex-shrink-0">
      {icon}
    </div>
    <div className="flex-1">
      <div className="text-[11px] font-bold tracking-[0.22em] text-[#c4d8ec]/80">
        {label}
      </div>
      <div className="mt-2">{value}</div>
    </div>
  </div>
);

const Footer = () => {
  return (
    <>
      <FooterBanner />
      <footer className="bg-[#0a0820] text-white" data-testid="site-footer">
        <div className="container-hc py-16 grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#c88a4a] to-[#a8c8e8] flex items-center justify-center">
                <Home size={20} className="text-white" />
              </div>
              <div className="font-serif-display text-3xl">Hillcrest</div>
            </div>
            <p className="mt-5 text-white/65 leading-relaxed max-w-md">
              Compassionate assisted living in the heart of San Augustine, Texas. Where your
              loved one feels at home.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <div className="text-xs font-bold tracking-[0.22em] text-white/60">QUICK LINKS</div>
            <ul className="mt-5 space-y-3">
              {[
                ["About Us", "#about"],
                ["Our Care", "#amenities"],
                ["Gallery", "#gallery"],
                ["Virtual Tour", "#tour"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-white/80 hover:text-[#c88a4a] transition-colors"
                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-xs font-bold tracking-[0.22em] text-white/60">CONTACT</div>
            <ul className="mt-5 space-y-4 text-white/85">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#a8c8e8] mt-1 flex-shrink-0" />
                <a href="tel:9362750222" className="hover:text-[#c88a4a] transition-colors">(936) 275-0222</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#a8c8e8] mt-1 flex-shrink-0" />
                <span>1997 Davidson Dr.<br />San Augustine, TX 75972</span>
              </li>
            </ul>

            <div className="mt-7 text-xs font-bold tracking-[0.22em] text-white/60">FOLLOW US</div>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              className="mt-4 inline-flex items-center gap-3 bg-[#2563a8] hover:bg-[#1d4f8a] transition-colors px-5 py-3 rounded-full font-semibold"
              data-testid="footer-facebook"
            >
              <Facebook size={18} /> Visit Us on Facebook
            </a>
            <p className="mt-4 text-sm text-white/55 leading-relaxed">
              See daily life at Hillcrest — activities, residents, holiday meals, and updates
              from our family to yours.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="container-hc py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/55">
            <div>© {new Date().getFullYear()} Hillcrest Assisted Living. All Rights Reserved.</div>
            <div>Equal Opportunity Employer · Equal Housing Opportunity</div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
